import React from 'react';

import { LoadingOutlined } from '@ant-design/icons';
import styled from '@emotion/styled';

import StatusCell from '../../../components/Badge/StatusCell';
import { formateDatimeStrToNiajaTime } from '../../../utils/utils';

interface LookupHeaderProps {
  companyName: string;
  status: string;
  companyLogoUri?: string;
  onboardedOn: string;
  loading?: boolean;
  isDeleted?: string;
}

const LookupHeader: React.FC<LookupHeaderProps> = ({
  loading,
  companyName,
  status,
  companyLogoUri,
  onboardedOn,
  isDeleted,
}) => {
  if (loading) {
    return <LoadingOutlined />;
  }

  return (
    <Container>
      <Img src={companyLogoUri || '/static/img/profilePlaceholder2.png'} />
      <TextArea>
        <FirstTextRow>
          <BoldText>{companyName}</BoldText>
          <StatusCell
            data={{ status }}
            statusKey='status'
            customClasses='small-border-radius'
            hasDot
          />

          {isDeleted === 'Deleted' && (
            <StatusCell
              data={{ status: isDeleted }}
              statusKey='status'
              customClasses='small-border-radius'
              hasDot
            />
          )}
        </FirstTextRow>

        <SecondTextRow>
          <span>Company</span>
        </SecondTextRow>

        <ThirdTextRow>
          <ThirdTextRowGroup>
            <div>On platform since:</div>
            <BoldNumberText>
              {formateDatimeStrToNiajaTime(onboardedOn)}
            </BoldNumberText>
          </ThirdTextRowGroup>
        </ThirdTextRow>
      </TextArea>
    </Container>
  );
};

export default LookupHeader;

const Container = styled.div`
  border: 1px solid ${({ theme }) => theme.palette.borderColor};
  padding: 32px;
  display: flex;
  gap: 16px;
  max-width: 827px;
  border-radius: 5px;

  gap: 24px;
`;

const TextArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  /* border: 1px solid red; */
`;

const Img = styled.img`
  width: 91px;
  height: 91px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid transparent;
`;

const BoldText = styled.span`
  font-weight: 600;
  font-size: 18px;
  line-height: 18px;
`;

const FirstTextRow = styled.div`
  display: flex;
  gap: 12px;
`;

const SecondTextRow = styled.div`
  display: flex;
  gap: 8px;
  color: ${({ theme }) => theme.palette.grayTextColor};
  font-size: 14px;
  line-height: 14px;
  font-weight: 400;
`;

const ThirdTextRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 27px;
  color: ${({ theme }) => theme.palette.grayTextColor};
`;

const ThirdTextRowGroup = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 11px;
`;

const BoldNumberText = styled.span`
  font-weight: 600;
  font-size: 14px;
  line-height: 14px;
`;
